
<el-row class="permanence black-inputs">
  <el-col :span="12" :offset="6" class="permanence-container">
    <div class="permanence-title">Rechercher un restaurant</div>
    <el-select class="permanence-selector" v-loading="loadingRestos" value-key="id" @change="updateDropdowns"
      v-model="value" filterable placeholder="Select">
      <el-option v-for="item in getAUsersOrdered" :key="item.id" :label="item.name" :value="item">
      </el-option>
    </el-select>
    <div class="permanence-button">
      <el-button v-if="value !== ''" type="success" round @click="gotoResto()">Voir le Restaurant</el-button>
    </div>
  </el-col>
</el-row>
